import { Dispatch, SetStateAction, useEffect, useState } from "react";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

import SpinnerComponent from "../../../../../Components/Loding/Spinner";

import {
    AtualizarGrupoController,
    GetGrupoController,
} from "../../../../../Controllers/Geral/Grupos/GruposController";
import {
    DesvincularGrupoModuloController,
    ListarModulosVinculadosPorGrupoController,
    VincularGrupoModuloController,
} from "../../../../../Controllers/Geral/Grupos/GruposModulosController";
import { ListarUsuariosPorGrupoController } from "../../../../../Controllers/Geral/Grupos/GruposUsuarioController";

import { GrupoInterface } from "../../../../../Interfaces/Geral/Grupos/GrupoInterfaces";
import { usuarioGrupo } from "../../../../../Interfaces/Geral/Grupos/GruposUsuarioInterface";
import { ModuloInterface } from "../../../../../Interfaces/Geral/Grupos/GruposModulosInterfaces";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import { useForm } from "react-hook-form";
import { useUserInfor } from "../../../../../Context/User";
import Modulos from "../../../../../Components/Modulos";

interface GeralProps {
    updateList: () => void;
    updateModal: (idGrupo: number) => void;
    setLoading: Dispatch<SetStateAction<boolean>>;
    loading: boolean;
    setlstUsuariosPorGrupo: Dispatch<SetStateAction<usuarioGrupo[]>>;
    lstUsuariosPorGrupo: usuarioGrupo[];
    idGrupo: number;
}
interface EditNameFormData {
    name: string;
}
interface ModuloDivInterface extends ModuloInterface {
    vinculado?: boolean;
}

export default function Geral(props: GeralProps) {
    const [getGrupo, setgetGrupo] = useState({} as GrupoInterface);

    const [lstModulos, setLstModulos] = useState(
        [] as Array<ModuloDivInterface>
    );

    const orgModulos = useUserInfor().OrgInfor.MODULOS;

    const { register, handleSubmit, formState } = useForm();

    useEffect(() => {
        if (props.idGrupo !== 0) {
            updateGrupo(props.idGrupo);
            updateUsers(props.idGrupo);
            updateModulos(props.idGrupo, orgModulos);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.idGrupo, orgModulos]);

    function updateGrupo(idGrupo: number) {
        GetGrupoController(idGrupo).then((response) => {
            setgetGrupo(response);
            props.setLoading(false);
        });
    }
    function updateUsers(idGrupo: number) {
        ListarUsuariosPorGrupoController(idGrupo).then((response) => {
            props.setLoading(false);
            props.setlstUsuariosPorGrupo(response);
        });
    }
    function updateModulos(
        idGrupo: number,
        orgModulos?: Array<ModuloInterface>
    ) {
        ListarModulosVinculadosPorGrupoController(idGrupo).then((response) => {
            const modulos =
                orgModulos?.map((orgModulo) => {
                    const moduloVinculado = response.find(
                        (moduloVinculado) =>
                            moduloVinculado.ID_MODULO === orgModulo.ID_MODULO
                    );
                    const vinculado = moduloVinculado !== undefined;
                    const ID_GRUPO_MODULO = moduloVinculado
                        ? moduloVinculado.ID_GRUPO_MODULO
                        : undefined;
                    return {
                        ...orgModulo,
                        vinculado,
                        ID_GRUPO_MODULO,
                    } as ModuloDivInterface;
                }) || [];
            props.setLoading(false);
            setLstModulos(modulos);
        });
    }

    function handleEditNameForm(data: EditNameFormData) {
        AtualizarGrupoController({
            ID_GRUPO: props.idGrupo,
            DS_GRUPO: data.name,
            FL_ANALISAR_CREDITO: getGrupo.FL_ANALISAR_CREDITO,
            FL_ATIVO: getGrupo.FL_ATIVO,
            FL_GERENCIAR_PRODUTOS: getGrupo.FL_GERENCIAR_PRODUTOS,
        }).then(() => {
            updateGrupo(props.idGrupo);
            props.updateModal(props.idGrupo);
            props.updateList();
        });
    }

    return !props.loading ? (
        <div className="Row1 d-flex flex-column flex-lg-row flex-lg-row-fluid ">
            <div className="d-flex flex-column justify-content-between align-items-center col-12 col-lg-6">
                <hr />

                <form
                    className="mb-3"
                    id="group-name-edit-form"
                    onSubmit={handleSubmit(handleEditNameForm)}
                >
                    <>
                        <input
                            className={`form-control placeholder-dark-75 ${
                                formState.errors.name && "is-invalid"
                            }`}
                            type="text"
                            defaultValue={getGrupo.DS_GRUPO}
                            name="name"
                            ref={register({
                                required: "Insira o nome do grupo",
                            })}
                        />
                        <div className="invalid-feedback">
                            {formState.errors.name
                                ? formState.errors.name.message
                                : ""}
                        </div>
                    </>

                    <button className="btn btn-outline-primary font-weight-bold">
                        <FontAwesomeIcon icon={faEdit} size="lg" />
                    </button>
                </form>

                <div className="row d-flex align-items-start justify-content-start">
                    <div className="col-4 d-flex flex-column align-itens-center justify-content-end">
                        <span
                            className="switch switch-outline switch-lg switch-icon switch-success d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="fL_ATIVO_STATUS"
                                    name="fL_ATIVO"
                                    checked={getGrupo.FL_ATIVO || false}
                                    type="checkbox"
                                    onChange={() => {
                                        AtualizarGrupoController({
                                            DS_GRUPO: getGrupo.DS_GRUPO,
                                            FL_ANALISAR_CREDITO:
                                                getGrupo.FL_ANALISAR_CREDITO,
                                            FL_GERENCIAR_PRODUTOS:
                                                getGrupo.FL_GERENCIAR_PRODUTOS,
                                            FL_ATIVO: !getGrupo.FL_ATIVO,
                                            ID_GRUPO: getGrupo.ID_GRUPO,
                                        }).then((response) => {
                                            updateGrupo(getGrupo.ID_GRUPO);
                                            props.updateList();
                                        });
                                    }}
                                />
                                <span></span>
                            </label>
                        </span>
                        <div className="text-center font-weight-bold">
                            Grupo Ativo
                        </div>
                    </div>
                    <div className="col-4 d-flex flex-column align-itens-center justify-content-end">
                        <span
                            className="switch switch-outline switch-lg switch-icon switch-info d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="fL_ANALISAR_CREDITO_STATUS"
                                    name="fL_ANALISAR_CREDITO"
                                    checked={
                                        getGrupo.FL_ANALISAR_CREDITO || false
                                    }
                                    type="checkbox"
                                    onChange={() => {
                                        AtualizarGrupoController({
                                            DS_GRUPO: getGrupo.DS_GRUPO,
                                            FL_ANALISAR_CREDITO:
                                                !getGrupo.FL_ANALISAR_CREDITO,
                                            FL_GERENCIAR_PRODUTOS:
                                                getGrupo.FL_GERENCIAR_PRODUTOS,
                                            FL_ATIVO: getGrupo.FL_ATIVO,
                                            ID_GRUPO: getGrupo.ID_GRUPO,
                                        }).then((response) => {
                                            updateGrupo(getGrupo.ID_GRUPO);
                                            props.updateList();
                                        });
                                    }}
                                />
                                <span></span>
                            </label>
                        </span>
                        <div className="text-center font-weight-bold">
                            Analisa Crédito
                        </div>
                    </div>
                    <div className="col-4 d-flex flex-column align-itens-center justify-content-end">
                        <span
                            className="switch switch-outline switch-lg switch-icon switch-warning d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="fL_GERENCIAR_PRODUTOS_STATUS"
                                    name="fL_GERENCIAR_PRODUTOS"
                                    checked={
                                        getGrupo.FL_GERENCIAR_PRODUTOS || false
                                    }
                                    type="checkbox"
                                    onChange={() => {
                                        AtualizarGrupoController({
                                            DS_GRUPO: getGrupo.DS_GRUPO,
                                            FL_ANALISAR_CREDITO:
                                                getGrupo.FL_ANALISAR_CREDITO,
                                            FL_GERENCIAR_PRODUTOS:
                                                !getGrupo.FL_GERENCIAR_PRODUTOS,
                                            FL_ATIVO: getGrupo.FL_ATIVO,
                                            ID_GRUPO: getGrupo.ID_GRUPO,
                                        }).then((response) => {
                                            updateGrupo(getGrupo.ID_GRUPO);
                                            props.updateList();
                                        });
                                    }}
                                />
                                <span></span>
                            </label>
                        </span>
                        <div className="text-center font-weight-bold">
                            Gerencia Produtos
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex-lg-row-fluid d-flex flex-column col-12 col-lg-6">
                <div className="RowCol1 align-items-center flex-row">
                    <h3 className="card-title align-items-center flex-row">
                        Módulos vinculados
                    </h3>
                    <div className="modulos d-flex flex-wrap">
                        {lstModulos.map((modulo) => {
                            return (
                                <OverlayTrigger
                                    key={modulo.ID_MODULO}
                                    overlay={(props) => (
                                        <Tooltip
                                            id={`${modulo.ID_MODULO}-tooltip`}
                                            {...props}
                                        >
                                            {modulo.DS_MODULO}
                                        </Tooltip>
                                    )}
                                >
                                    <div
                                        onClick={() => {
                                            if (
                                                modulo.vinculado &&
                                                modulo.ID_GRUPO_MODULO
                                            ) {
                                                DesvincularGrupoModuloController(
                                                    modulo.ID_GRUPO_MODULO
                                                ).then((res) => {
                                                    updateModulos(
                                                        props.idGrupo,
                                                        orgModulos
                                                    );
                                                });
                                            } else {
                                                VincularGrupoModuloController({
                                                    ID_GRUPO: props.idGrupo,
                                                    ID_MODULO: modulo.ID_MODULO,
                                                    ID_GRUPO_MODULO: 0,
                                                }).then(() => {
                                                    updateModulos(
                                                        props.idGrupo,
                                                        orgModulos
                                                    );
                                                });
                                            }
                                        }}
                                        /**/
                                    >
                                        {Modulos(
                                            modulo.ID_MODULO,
                                            modulo.DS_MODULO,
                                            `modulo ${
                                                modulo.vinculado
                                                    ? "active"
                                                    : "disabled"
                                            }`
                                        )}
                                    </div>
                                </OverlayTrigger>
                            );
                        })}
                    </div>
                </div>
                <br />
                <div className="RowCol2 align-items-center flex-row">
                    <h3>Usuários do grupo</h3>
                    <hr />
                    {props.lstUsuariosPorGrupo?.map((response) => {
                        return (
                            <span
                                className="label label-lg font-weight-bold  label-light-primary label-inline mr-2 mt-2"
                                key={response.ID_USUARIO}
                            >
                                {response.DS_NOME}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}
